import React from "react";
import { motion } from "framer-motion";

import { fadeIn } from "../variants";
import { reservationData } from "../data";

const Reservation = () => {
  const {
    title,
    dividerImg,
    availability,
    contactEmail,
    contactNumber,
    endingMessage,
    endingExpectation,
  } = reservationData;
  return (
    <section className="relative top-96 z-10 lg:top-[480] min-h-[720px]">
      <div className="container mx-auto">
        <motion.div
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          initial="hidden"
          whileInView={"show"}
          className="flex-1 text-center lg:text-left lg:pt-16"
        >
          <div className="flex justify-center items-center text-red-300 h2 capitalize">
            {title}
          </div>
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView={"show"}
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          className="flex justify-center items-center text-center"
        >
          <img src={dividerImg} alt="" />
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView={"show"}
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          className="text-center"
        >
          <div className="mb-2">
            <p>You may contact us directly through</p>
          </div>

          <p>
            Email: <b>{contactEmail}</b>
          </p>

          <p>
            <b>or</b>
          </p>
          <p>
            Reach us out at: <b>{contactNumber}</b>
          </p>
          <div className="mt-2">
            <p className="flex justify-center items-center text-center mb-2">
              {availability}
            </p>
          </div>
          <p className="flex justify-center items-center text-center">
            {endingMessage}
          </p>
          <p className="flex justify-center items-center text-center">
            {endingExpectation}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Reservation;
